import React from 'react';

/**
 * `ReasonsToExtend` renders the "Reasons to extend" informational sidebar
 * section.
 *
 * It delegates list rendering to the shared `List` component and adds a divider
 * below.
 */

import { TitledList } from '../../common/CommonTypes';
import List from '../../common/List';
import './RenewalsPageInfo.scss';

export type ReasonsToExtendProps = {
  reasonsToExtend: TitledList;
};

const ReasonsToExtend = ({
  reasonsToExtend
}: ReasonsToExtendProps): JSX.Element => {
  return (
    <div className='info'>
      <div className='m05-bottom'>
        <List id='reasons-to-protect' list={reasonsToExtend} />
      </div>
      <hr />
    </div>
  );
};
export default ReasonsToExtend;
